'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MessagesIcon = require('./MessagesIcon');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MessagesIcon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/MessagesIcon/index.js
// module id = 1230
// module chunks = 1